<mapfre-header></mapfre-header>
<div class="container mapfre-content" [ngClass]="{'mk-payment-error': !isAcmic}">
    <mapfre-card>

        <div class="row text-center margin-vertical mv16">
            <ng-container>
                <ng-container>
                    <mapfre-alert></mapfre-alert>
                    <section class="row policy-details-content no-margin-horizontal details-content">
                        <div>
                            <div class="header-icon margin-bottom mb24 text-center">
                                <ng-container *ngIf="isAcmic; else MAStateImpIcon">
                                    <svg-important-message-svg></svg-important-message-svg>
                                </ng-container>
                                <ng-template #MAStateImpIcon>
                                    <img src="./assets/img/images/icon-important-message.svg" width="48" height="48" alt="important message icon" />
                                </ng-template>
                                <h2 class="title-copy text-center margin-top mt8 mb-2 error-message-payment">
                                    {{ 'Unable to process the payment' }}
                                </h2>
                                <h6 class="p-2 mb-2 title-copy text-center grey-color confirm-payment error-help-font font-class">
                                    {{ 'Please review your payment details. If you continue having difficulties, contact our Customer service Department at' }}
                                </h6>                                
                                <ng-container *ngIf="isAcmic; else MAstate">
                                    <h6 class="title-copy text-center grey-color confirm-payment error-help-font">
                                        <div><a href="tel:18442954500" class="underline">1-844-295-4500</a> </div>
                                        <div class="info">{{ 'CONTACT_CENTER_HOURS_ACMIC' | translate }}</div>
                                        <div class="info">{{ 'CONTACT_CENTER_HOURS_2_ACMIC' | translate }}</div>
                                    </h6>
                                </ng-container>
                                <ng-template #MAstate>
                                    <h6 class="mt-4 text-center grey-color confirm-payment error-help-font">
                                        <div><a href="tel:18009228276" class="font-size medium-font dm-sans-medium mapfre link red-link underline">1-800-922-8276</a> </div>
                                        <div class="info-error mt-2">{{ '8am - 6pm (EST) Mon - Fri' }}</div>
                                    </h6>
                                </ng-template>
                            </div>

                            <div class="text-center margin-top mt32">
                                <div>
                                    <mapfre-button additionalClasses="basic primary large-btn review-payment-btn" (click)="goToNewPayment()">
                                        {{ 'Review payment details' | translate}}
                                    </mapfre-button>
                                </div>
                                <div class="mt-4">
                                    <mapfre-button additionalClasses="ghost secondary medium-btn review-payment-btn" (click)="gotoMakePayment()">
                                        {{ 'CANCEL' | translate}}
                                    </mapfre-button>
                                </div>
                            </div>
                        </div>
                    </section>
                </ng-container>
            </ng-container>
        </div>
    </mapfre-card>
</div>